import { useSearchParams } from "react-router-dom";
import { Button } from "@components/Button/Button";
import { RenderImg } from "@components/RenderIcon/RenderImg";
import ThinkingImg from "@assets/images/Thinking.svg";
import { useTranslation } from "react-i18next";
import { Wrapper, InfoWrapper, IconWrapper, ButtonWrapper } from "./component";
import { TopicStyle, DescStyle } from "./style";
import { onPostMsgToGrab } from "./functional";
import liff from "@line/liff";
import { useEffect } from "react";
import { GRAB_HELP_CENTER_URL } from "@configs";

export const UnLinkFailPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [queryParameters] = useSearchParams();

  const langParam = queryParameters.get("lang");

  useEffect(() => {
    if (langParam !== null) {
      i18n.changeLanguage(langParam, (err) => {
        if (!err) {
          localStorage.setItem("preferredLanguage", langParam);
        }
      });
    }
  }, [langParam]);

  return (
    <Wrapper>
      <IconWrapper>
        <RenderImg
          src={ThinkingImg}
          alt="thinking"
          width={"50%"}
          height={"auto"}
        />
      </IconWrapper>
      <InfoWrapper>
        <TopicStyle className="text-center">
          {t("status.unlink.fail.topic")}
        </TopicStyle>
        <DescStyle className="text-center">
          {t("status.unlink.fail.desc")}
        </DescStyle>
        <ButtonWrapper>
          <Button
            variant="success"
            onClick={() => {
              liff.closeWindow();
              onPostMsgToGrab({
                msg: "ERROR:UNLINK_FAILED",
              });
            }}>
            {t("button.close")}
          </Button>
          <Button
            variant="info"
            onClick={() => {
              window.location.replace(GRAB_HELP_CENTER_URL);
            }}>
            {t("button.view_help_center")}
          </Button>
        </ButtonWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
